'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _keys = require('lodash/keys');

var _keys2 = _interopRequireDefault(_keys);

var _omit = require('lodash/omit');

var _omit2 = _interopRequireDefault(_omit);

var _Tooltip = require('../Tooltip');

var _Tooltip2 = _interopRequireDefault(_Tooltip);

var _BounceLoading = require('../BounceLoading');

var _BounceLoading2 = _interopRequireDefault(_BounceLoading);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Button = (_temp = _class = function (_React$Component) {
  (0, _inherits3.default)(Button, _React$Component);

  function Button() {
    (0, _classCallCheck3.default)(this, Button);
    return (0, _possibleConstructorReturn3.default)(this, (Button.__proto__ || Object.getPrototypeOf(Button)).apply(this, arguments));
  }

  (0, _createClass3.default)(Button, [{
    key: 'getChildProps',
    value: function getChildProps() {
      var omitKeys = (0, _keys2.default)(Button.propTypes);
      if (this.props.disabled || this.props.loading) {
        omitKeys.push('onClick');
      }
      return _omit2.default.apply(undefined, [this.props].concat((0, _toConsumableArray3.default)(omitKeys)));
    }
  }, {
    key: 'getClassName',
    value: function getClassName() {
      var classes = ['orion_button'];
      if (this.props.disabled) {
        classes.push('orion_disabled');
      } else if (this.props.loading) {
        classes.push('orion_loading');
      } else if (this.props.danger) {
        classes.push('orion_danger');
      } else if (this.props.primary) {
        classes.push('orion_primary');
      }
      if (this.props.big) {
        classes.push('orion_big');
      }
      if (this.props.fullWidth) {
        classes.push('orion_fullWidth');
      }
      return classes.join(' ');
    }
  }, {
    key: 'renderInner',
    value: function renderInner() {
      if (this.props.loading) {
        return _react2.default.createElement(_BounceLoading2.default, null);
      }if (this.props.label) {
        return this.props.label;
      } else {
        return this.props.children;
      }
    }
  }, {
    key: 'renderButton',
    value: function renderButton() {
      return _react2.default.createElement(
        'span',
        { className: this.getClassName(), style: this.props.style },
        this.renderInner()
      );
    }
  }, {
    key: 'renderLinkButton',
    value: function renderLinkButton() {
      return _react2.default.createElement(
        'a',
        this.getChildProps(),
        this.renderButton()
      );
    }
  }, {
    key: 'renderMain',
    value: function renderMain() {
      if (this.props.linkButton || this.props.href || this.props.to) {
        return this.renderLinkButton();
      } else {
        return _react2.default.createElement(
          'span',
          (0, _extends3.default)({ className: 'os_button_container' }, this.getChildProps()),
          this.renderButton()
        );
      }
    }
  }, {
    key: 'render',
    value: function render() {
      if (this.props.tooltip) {
        return _react2.default.createElement(
          _Tooltip2.default,
          { content: this.props.tooltip },
          this.renderMain()
        );
      } else {
        return this.renderMain();
      }
    }
  }]);
  return Button;
}(_react2.default.Component), _class.propTypes = {
  tooltip: _propTypes2.default.string,
  to: _propTypes2.default.string,
  linkButton: _propTypes2.default.bool,
  label: _propTypes2.default.any,
  children: _propTypes2.default.any,
  primary: _propTypes2.default.bool,
  danger: _propTypes2.default.bool,
  big: _propTypes2.default.bool,
  style: _propTypes2.default.object,
  disabled: _propTypes2.default.bool,
  loading: _propTypes2.default.bool,
  fullWidth: _propTypes2.default.bool
}, _class.defaultProps = {
  linkButton: false,
  primary: false,
  danger: false,
  big: false,
  style: {},
  disabled: false,
  fullWidth: false
}, _temp);
exports.default = Button;


//////////////////
// WEBPACK FOOTER
// ./node_modules/orionsoft-parts/lib/components/Button/withoutLink.js
// module id = 1111
// module chunks = 85